// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + "8fd77751" + ".chunk.js";
};